import { render } from "./FilamentType.vue?vue&type=template&id=78ab3734&scoped=true"
import script from "./FilamentType.vue?vue&type=script&lang=js"
export * from "./FilamentType.vue?vue&type=script&lang=js"

import "./FilamentType.vue?vue&type=style&index=0&id=78ab3734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ab3734"]])

export default __exports__